export default __webpack_public_path__ + "static/media/File_Open.2210cb66.svg";